import { useT } from "../../../core/i18n";
import React, { useState } from "react";
import Table from "../../../core/common/dataTable/index";
import {
  getDocument,
  employeesVerificationUpdate,
  getEmployeesVerification,
  getEmployeesFaceVerificationHistory,
} from "../../../core/data/redux/employeesVerificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { Avatar } from "antd";
import { Link } from "react-router";
import { randomAvatar } from "../../../core/hooks/commonFunctions";

interface EmployeesVerificationTableProps {
  userId?: number;
  type: string;
  setItem: (item: any) => void;
}

const EmployeeFaceVerificationTable = (
  props: EmployeesVerificationTableProps
) => {
  const { t } = useT();
  const { type, setItem } = props;
  const dispatch = useDispatch();
  const employeesVerificationState = useSelector(
    (state: any) => state.employeesVerificationState
  );
  const [dataList, setDataList] = React.useState<any[]>([]);
  console.log(dataList);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  const fetchRecords = () => {
    dispatch(
      getEmployeesFaceVerificationHistory({
        page: pagination.current,
        limit: pagination.pageSize,
        //  is_verified: type
      })
    );
  };

  const getDocumentUrl = async (record: any) => {
    setItem(record);
    await dispatch(getDocument({ id: record.id }));
  };

  React.useEffect(() => {
    fetchRecords();
  }, [type]);

  React.useEffect(() => {
    if (
      employeesVerificationState.loading === "fulfilled" &&
      employeesVerificationState.action === "update"
    ) {
      fetchRecords();
    } else if (
      employeesVerificationState.loading === "fulfilled" &&
      employeesVerificationState.action === "list"
    ) {
      const result = employeesVerificationState?.data?.data || null;

      if (result.data && result.data.length > 0) {
        const employees = result?.data || [];
        setDataList(employees);
        setPagination({
          ...pagination,
          total: result.total || employees.length,
          current: result.page || 1,
          pageSize: result.limit || 10,
        });
      } else {
        setDataList([]);
      }
    }
  }, [employeesVerificationState.loading]);

  const columns = [
    {
      title: t("sr_no"),
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <div>
          {pagination.current
            ? index +
            pagination.current * pagination.pageSize -
            pagination.pageSize +
            1
            : index + 1}
        </div>
      ),
    },
    // {
    //   title: t("employee_name"),
    //   dataIndex: "employee",
    //   render: (employee: any) => {
    //     return employee?.details?.firstname || ""
    //   }
    // },

    {
      title: t("name"),
      dataIndex: "employee",
      render: (employee: any, record: any) => {

        console.log('record',record)
        const first = employee?.details?.firstname?.trim() || "";
        const last =
          employee?.details?.lsastname?.trim() || employee?.details?.lastname?.trim() || "";

        if (!first && !last) {
          return <div style={{ height: "40px" }}></div>;
        }

        const avatarInfo = randomAvatar(first);

        return (
          <div className="d-flex align-items-center text-decoration-none">
            {record?.photo ? (
              <Avatar
                src={`${record?.photo}`}
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: "50px",
                  height: "50px",
                }}
              >{record?.photo}</Avatar>
            ) : (
              <Avatar
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: "50px",
                  height: "50px",
                }}
              >
                {avatarInfo.initial}
              </Avatar>
            )}
            <div className="text-primary">{`${first} ${last}`.trim()}</div>
          </div>
        );
      },
    },
    

    {
      title: t("emp_id"),
      dataIndex: "empId",
      render: (text: any, record: any) =>
        record?.employee?.details?.empId ? parseInt(record.employee.details.empId, 10) : "",
    },
    {
      title: t("wing"),
      dataIndex: "employee",
      render: (employee: any) =>
        employee?.details?.sap_department_designation_wings?.wing_name ? `${employee?.details?.sap_department_designation_wings?.wing_name}` : "",
    },
    {
      title: t("department"),
      dataIndex: "employee",
      render: (employee: any) =>
        employee?.details?.sap_department_designation_wings?.department_name ? `${employee?.details?.sap_department_designation_wings?.department_name}` : "",
    },
    {
      title: t("designation"),
      dataIndex: "employee",
      render: (employee: any) =>
        employee?.details?.sap_department_designation_wings?.designation_name ? `${employee?.details?.sap_department_designation_wings?.designation_name}` : "",
    },
    {
      title: t("email"),
      dataIndex: "email",
      render: (text: any, record: any) =>
        record?.employee?.details?.email || "",
    },
    {
      title: t("phone"),
      dataIndex: "phone",
      render: (text: any, record: any) =>
        record?.employee?.details?.phone || "",
    },

    {
      title: t("is_verified"),
      dataIndex: "is_verified",
      render: (is_verified: any) => {
        const badgeClass =
          is_verified === "VERIFIED"
            ? "badge-success"
            : is_verified === "REJECTED"
              ? "badge-danger"
              : "badge-info";
        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            {is_verified}
          </span>
        );
      },
    },
    {
      title: t("is_active"),
      dataIndex: "is_archived",
      sorter: (a: any, b: any) => a.is_verified.length - b.is_verified.length,
      render: (is_archived: any, record: any) => {
        return (
          <span style={{ minWidth: 60, padding: 2, textAlign: 'center', cursor: 'pointer' }} className={`badge ${(is_archived) ? 'badge-danger' : 'badge-success'}  align-items-center badge-xs`}>
            {is_archived ? 'Inactive' : 'Active'}
          </span>
        )
      },
    },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   width: 100,
    //   render: (text: string, record: any) => (
    //     <div className="action-icon d-inline-flex">
    //       <button
    //         className="btn btn-primary btn-sm"
    //         data-bs-toggle="modal"
    //         data-inert={true}
    //         data-bs-target="#verify-doc"
    //         onClick={() => getDocumentUrl(record)}
    //       >
    //         <i className="ti ti-eye me-2" />
    //         View
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const handlePagination = (pagination: any) => {
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    fetchRecords();
  };
  return (
    <div>
      <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
          <h4 className="mb-4 mt-3">{t("face_data_verification_list")}</h4>
        </div>
        <div className="card-body p-0 py-3">
          <Table
            columns={columns}
            dataSource={dataList}
            Selection={false}
            paginationConfig={pagination}
            handlePagination={handlePagination}
            loading={employeesVerificationState.loading === "pending"}
          />
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-md-12">
          <div className="datatable-paginate mt-4" />
        </div>
      </div>
    </div>
  );
};

export default EmployeeFaceVerificationTable;
